var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40.61 28.34",
    style: {
      enableBackground: "new 0 0 40.61 28.34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AFDADB;}\r\n\t.st1{fill:#00386C;}\r\n\t.st2{fill:#2F9BAB;}\r\n\t.st3{fill:#54BDC9;}\r\n\t.st4{opacity:0.13;}\r\n\t.st5{fill:#231F20;}\r\n\t.st6{opacity:0.5;fill:#FFFFFF;}\r\n\t.st7{clip-path:url(#SVGID_00000088125960905422303160000017540014404150231981_);}\r\n\t.st8{fill:none;stroke:#787878;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M37.11,27.54H3.5c-1.49,0-2.7-1.21-2.7-2.7V3.5c0-1.49,1.21-2.7,2.7-2.7h33.61c1.49,0,2.7,1.21,2.7,2.7v21.34 C39.81,26.34,38.6,27.54,37.11,27.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1.57,1.62l17.51,15.09c0.71,0.61,1.76,0.61,2.47,0L39.05,1.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 13.89,
    y1: 12.24,
    x2: 1.25,
    y2: 26.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 26.72,
    y1: 12.24,
    x2: 39.36,
    y2: 26.34
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.34c380652d091902b5d451e7e083be48.svg";
export { ForwardRef as ReactComponent };